import { put, takeLatest, call } from 'redux-saga/effects';
import { SEND_BROADCAST } from './constants';
import { sendBroadcastSuccess, sendBroadcastError } from './actions';
import { fetchData } from '../api';

export function* sendBroadcast({ payload }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/broadcasts`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': window.localStorage.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };
    const result = yield call(fetchData, url, config);
    yield put(sendBroadcastSuccess(result));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(sendBroadcastError(error));
  }
}

export default function* broadcastSaga() {
  yield takeLatest(SEND_BROADCAST, sendBroadcast);
}
